import { Exception, LaunchDarklyService, ToasterService } from '@anddone/ui-utilities';
import { Component, EventEmitter, Input, Output, signal, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ReportsService } from '../../../../../services/reports.service';
import { Report } from '../report.model';
import { MessageConstants } from '../../../../../constants/message.constant';
import { FrequencyEnumMapping } from '../../../../../enum/frequency.enum';
import { TranslateModule } from '@ngx-translate/core';
import { Loader } from '../../../../layout/loader/loader';
import { AppSetting } from '../../../../../constants/appsetting.constant';

@Component({
  selector: 'app-report-card',
  imports: [Loader, TranslateModule],
  templateUrl: './report-card.html',
  styleUrl: './report-card.scss',
})
export class ReportCard implements OnInit {
  @Input() report!: Report;
  @Output() outputData = new EventEmitter();
  isLoader = signal<boolean>(false);
  featureFlags: any;

  private router = inject(Router);
  private toasterService = inject(ToasterService);
  private reportsService = inject(ReportsService);
  private launchDarklyService = inject(LaunchDarklyService);

  ngOnInit() {
    // Get all feature flags for the project and subscribe to changes
    this.featureFlags = this.launchDarklyService.getAllFeatureFlags(
      AppSetting.launchDarklyProjectName
    );
    this.launchDarklyService.LD_emitters[AppSetting.launchDarklyProjectName]?.subscribe(
      (allFlags: any) => {
        this.featureFlags = allFlags;
      }
    );
  }

  routeToReport() {
    this.router.navigate(['/ally/reports/generate-reports/', this.report.reportId], {
      state: { reportName: this.report.name },
    });
  }

  /* enable/disable report api call */
  activateDeactivateSubscription(data: any) {
    if (!this.report?.subscriptionId) {
      this.addReportSubscription();
      return;
    }
    this.isLoader.set(true);
    if (this.featureFlags?.enable_report_api_v3) {
      const reqUrl = !data.hasAutoGenerate
        ? this.reportsService.activateReport(this.report?.subscriptionId)
        : this.reportsService.deactivateReport(this.report?.subscriptionId);
      reqUrl.subscribe({
        next: (_res: any) => {
          const msg = !data.hasAutoGenerate
            ? MessageConstants.report.subscribeSuccess
            : MessageConstants.report.unsubscribeSuccess;
          this.toasterService.showSuccess(msg, 'full');
          data.hasAutoGenerate = !data.hasAutoGenerate;
          this.isLoader.set(false);
          this.outputData.emit('refreshReports');
        },
        error: (error) => {
          this.isLoader.set(false);
          data.hasAutoGenerate = !data.hasAutoGenerate;
          const toastMessage = Exception.exceptionMessage(error);
          this.toasterService.showError(toastMessage.join(', '), 'full');
        },
      });
    } else {
      const reqUrl = !data.hasAutoGenerate
        ? this.reportsService.activateOldReport(this.report?.subscriptionId)
        : this.reportsService.deactivateOldReport(this.report?.subscriptionId);
      reqUrl.subscribe({
        next: (_res: any) => {
          const msg = !data.hasAutoGenerate
            ? MessageConstants.report.subscribeSuccess
            : MessageConstants.report.unsubscribeSuccess;
          this.toasterService.showSuccess(msg, 'full');
          data.hasAutoGenerate = !data.hasAutoGenerate;
          this.isLoader.set(false);
          this.outputData.emit('refreshReports');
        },
        error: (error) => {
          this.isLoader.set(false);
          data.hasAutoGenerate = !data.hasAutoGenerate;
          const toastMessage = Exception.exceptionMessage(error);
          this.toasterService.showError(toastMessage.join(', '), 'full');
        },
      });
    }
  }

  addReportSubscription() {
    let reqObj: any;
    if (this.featureFlags?.enable_report_api_v3) {
      reqObj = {
        reportId: this.report.reportId,
        subscriptionStatus: 'On',
        frequency: FrequencyEnumMapping.Daily,
        frequencyParam: '1',
      };
    } else {
      reqObj = {
        reportId: this.report.reportId,
        subscriptionStatus: 'On',
        frequency: FrequencyEnumMapping.Daily,
        frequencyParam: '11:50',
      };
    }
    if (this.report.name === 'Monthly Profitability Report') {
      reqObj.frequency = FrequencyEnumMapping.Monthly;
      reqObj.frequencyParam = '1';
    }
    this.isLoader.set(true);
    if (this.featureFlags?.enable_report_api_v3) {
      this.reportsService.addReportSubscriptions(reqObj)?.subscribe({
        next: (_res: any) => {
          this.isLoader.set(false);
          this.toasterService.showSuccess(MessageConstants.report.subscribeSuccess, 'full');
          this.outputData.emit('refreshReports');
        },
        error: (er) => {
          this.isLoader.set(false);
          const toastMessage = Exception.exceptionMessage(er);
          this.toasterService.showError(toastMessage.join(', '), 'full');
        },
      });
    } else {
      this.reportsService.addOldReportSubscriptions(reqObj).subscribe({
        next: (_res: any) => {
          this.isLoader.set(false);
          this.toasterService.showSuccess(MessageConstants.report.subscribeSuccess, 'full');
          this.outputData.emit('refreshReports');
        },
        error: (er) => {
          this.isLoader.set(false);
          const toastMessage = Exception.exceptionMessage(er);
          this.toasterService.showError(toastMessage.join(', '), 'full');
        },
      });
    }
  }
}
